import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import ArrowRightLight from 'src/assets/images/ArrowRightLight.svg';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { setActiveNavLink } from 'src/pages/home/redux/actions';
import {
    resetCartData,
    resetEquityDetails,
    resetEquityDropDownDetails,
    resetEquityReference,
    reSetProgressBarStatus as equityReSetProgressBarStatus,
    resetCreateEquity,
    resetCreateUpdateEquity,
} from 'src/pages/equity/redux/actions';
import {
    resetDetailsDropdownReducer,
    resetPriceOverrideDetails,
    resetValidatedData,
    setPriceOverride,
    setPriceOverrideNotes,
    setPriceOverrideReason,
    storePaymentDetails,
    setInventoryItems,
    resetSurgeryDetails,
    resetItemTableData,
    reSetProgressBarStatus,
    resetConsignmentSubmittedData,
    applyShipToAdderess,
    getInventoryCheckedItems,
    resetItemPrices,
    createItemTableCopy,
    resetConsignmentMyCaseRefReference,
    resetCreateOrUpdateSurgery as resetCreateConsignment,
} from 'src/pages/consignmentBilling/redux/actions';
import {
    setInventoryItemsDetails,
    reSetProgressBarStatus as returnResetProgressBarStatus,
    resetItemTableData as returnResetItemTableData,
    resetSurgeryDetails as returnResetSurgeryDetails,
    resetConsignmentReturnOrder,
    resetConsignmentReturnMyCaseRefReference,
} from 'src/pages/consignmentReturn/redux/actions';
import {
    getRoutePathWithParams,
    hideScrolling,
    resumeScrolling,
} from 'src/utils/util';
import {
    resetConsignmentAddReference,
    resetConsignmentAddDetails,
    resetConsignmentAddDropDownDetails,
    resetCartData as resetConsignmentAddCartData,
    reSetProgressBarStatus as resetConsignmentAddProgressBarStatus,
    resetCreateconsignmentAdd,
    resetCreateUpdateConsignmentAdd,
} from 'src/pages/consignmentAdd/redux/actions';
import {
    resetBomData,
    resetSurgeryDetails as surgeryResetSurgeryDetails,
    reSetProgressBarStatus as resetSurgeryProgressBarStatus,
    resetSurgeryDetailsReducer,
    resetShipToAddress,
    resetCreateOrUpdateSurgery,
} from 'src/pages/scheduleSurgery/redux/actions';
import { resetNotes, setIsMastOrder, getConfigurations, setPediatricCheck } from 'src/common/redux/actions';
import { useTranslation } from 'react-i18next';
import { CONSIGNMENT_RETURN } from 'src/constants/appConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const NewOrdersPopup = (props) => {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const newOrderMethods = [
        { id: 'scheduleSurgery', name: t('templates.surgeryTemplate.surgery') },
        { id: 'mastSurgery', name: t('orders.orderTypes.MAST') },
        { id: 'equity', name: t('createOrderMethods.createEquity') },
        {
            id: 'consignmentBilling',
            name: t('createOrderMethods.createConsigmentBilling'),
        },
        {
            id: 'consignmentReturn',
            name: t('createOrderMethods.createConsignmentReturn'),
        },
        {
            id: 'consignmentAdd',
            name: t('createOrderMethods.createConsigmentAdd'),
        },
    ];

    const { createOrderDetails } = useSelector((state) => state.loginReducer);
    const handleOnClick = (method) => {
        sessionStorage.removeItem('myCaseRefID');
        switch (method.name) {
            case newOrderMethods[0].name:
                dispatch(setIsMastOrder(false));
                // dispatch(getConfigurations({ resourceType: 'visibility', module: 'SCHEDULE_SURGERY' }, 'SCHEDULE_SURGERY'));
                dispatch(setActiveNavLink(
                    (location?.pathname || '').includes('/orders')
                        ? { calendar: false, orders: true }
                        : { calendar: true, orders: false }
                ));
                dispatch(resetSurgeryDetailsReducer());
                dispatch(resetShipToAddress());
                dispatch(resetCreateOrUpdateSurgery());
                dispatch(surgeryResetSurgeryDetails());
                dispatch(resetBomData());
                dispatch(setPediatricCheck(''));
                dispatch(resetNotes());
                dispatch(resetSurgeryProgressBarStatus());
                localStorage.removeItem('alertDatesforConsignmentAdd');
                history.push({
                    ...getRoutePathWithParams('/scheduleSurgery'),
                    state: {
                        from: location?.pathname ? location.pathname : null,
                    },
                });
                break;
            case newOrderMethods[1].name:
                dispatch(setIsMastOrder(true));
                // dispatch(getConfigurations({ resourceType: 'visibility', module: 'MAST' }, 'MAST'));
                dispatch(setActiveNavLink(
                    (location?.pathname || '').includes('/orders')
                        ? { calendar: false, orders: true }
                        : { calendar: true, orders: false }
                ));
                dispatch(resetSurgeryDetailsReducer());
                dispatch(resetShipToAddress());
                dispatch(resetCreateOrUpdateSurgery());
                dispatch(surgeryResetSurgeryDetails());
                dispatch(resetBomData());
                dispatch(setPediatricCheck(''));
                dispatch(resetNotes());
                dispatch(resetSurgeryProgressBarStatus());
                localStorage.removeItem('alertDatesforConsignmentAdd');
                history.push({
                    ...getRoutePathWithParams('/scheduleSurgery'),
                    state: {
                        from: location?.pathname ? location.pathname : null,
                    },
                });
                break;
            case newOrderMethods[2].name:
                dispatch(setActiveNavLink({ calendar: false, orders: true }));
                dispatch(resetEquityReference());
                dispatch(resetEquityDetails());
                dispatch(resetEquityDropDownDetails());
                dispatch(resetNotes());
                dispatch(equityReSetProgressBarStatus());
                dispatch(resetCartData());
                dispatch(resetCreateEquity());
                dispatch(resetCreateUpdateEquity());
                history.push({
                    ...getRoutePathWithParams('/equity'),
                    state: {
                        from: location?.pathname ? location.pathname : null,
                    },
                });
                // window.location.href = ordersWCMSLinks('orderEquity');
               // dispatch(getConfigurations({resourceType: 'visibility', module: 'EQUITY'},'EQUITY'));
                break;
            case newOrderMethods[3].name:
                dispatch(setActiveNavLink({ calendar: false, orders: true }));
                // dispatch(getConfigurations({resourceType: 'visibility', module: 'CONSIGNMENT_BILLING'},'CONSIGNMENT_BILLING'));
                dispatch(resetConsignmentMyCaseRefReference());
                dispatch(resetSurgeryDetails());
                dispatch(setPriceOverrideReason(''));
                dispatch(resetDetailsDropdownReducer());
                dispatch(resetItemTableData());
                dispatch(setPriceOverride(false));
                dispatch(reSetProgressBarStatus());
                dispatch(resetConsignmentSubmittedData());
                dispatch(resetCreateConsignment());
                dispatch(resetNotes());
                 dispatch(createItemTableCopy([]));
                dispatch(applyShipToAdderess([]));
                dispatch(getInventoryCheckedItems([]));
                dispatch(resetItemPrices());
                dispatch(setInventoryItems([]));
                dispatch(storePaymentDetails([]));
                dispatch(resetValidatedData());
                dispatch(setPriceOverrideNotes(''));
                dispatch(resetPriceOverrideDetails());
                history.push({
                    ...getRoutePathWithParams('/consignmentBilling'),
                    state: {
                        from: location?.pathname ? location.pathname : null,
                    },
                });
                break;
            case newOrderMethods[4].name:
                // dispatch(getConfigurations({resourceType: 'visibility', module: CONSIGNMENT_RETURN}, CONSIGNMENT_RETURN));
                dispatch(setActiveNavLink({ calendar: false, orders: true }));
                dispatch(resetConsignmentReturnMyCaseRefReference());
                dispatch(returnResetProgressBarStatus());
                dispatch(returnResetItemTableData());
                dispatch(returnResetSurgeryDetails());
                dispatch(resetConsignmentReturnOrder());
                dispatch(setInventoryItemsDetails([]));
                history.push({
                    ...getRoutePathWithParams('/consignmentReturn'),
                    state: {
                        from: location?.pathname ? location.pathname : null,
                    },
                });
                break;
            case newOrderMethods[5].name:
                dispatch(resetConsignmentAddReference());
                dispatch(resetConsignmentAddDetails());
                dispatch(resetConsignmentAddCartData());
                // dispatch(getConfigurations({resourceType: 'visibility', module: 'CONSIGNMENT_ADD'},'CONSIGNMENT_ADD'));
                dispatch(setActiveNavLink({ calendar: false, orders: true }));
                dispatch(resetConsignmentAddDropDownDetails());
                dispatch(resetNotes());
                dispatch(resetConsignmentAddProgressBarStatus());
                dispatch(resetCreateconsignmentAdd());
                dispatch(resetCreateUpdateConsignmentAdd());
                history.push({
                    ...getRoutePathWithParams('/consignmentAdd'),
                    state: {
                        from: location?.pathname ? location.pathname : null,
                    },
                });
                break;
            default:
                break;
        }
    };
    const listRef = useRef(null);
    const lastScrollTopRef = useRef(0);
    const originalBodyStylesRef = useRef({});

    useEffectWithErrorLogging(() => {
        const isIOS = () =>
            /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

        // For non-iOS, use existing global lock. For iOS, lock body via fixed positioning.
        if (!isIOS()) {
            hideScrolling();
        } else {
            const body = document.body;
            const style = body.style;
            originalBodyStylesRef.current = {
                position: style.position,
                top: style.top,
                left: style.left,
                right: style.right,
                overflow: style.overflow,
                width: style.width,
            };
            const scrollY = window.scrollY;
            style.position = 'fixed';
            style.top = `-${scrollY}px`;
            style.left = '0';
            style.right = '0';
            style.overflow = 'hidden';
            style.width = '100%';
        }

        const stopProp = (e) => {
            e.stopPropagation();
        };

        // iOS edge guard to prevent rubber-band bounce and anchor jump
        let startY = 0;
        const onTouchStart = (e) => {
            const el = listRef.current;
            if (!el) return;
            startY = e.touches ? e.touches[0].clientY : e.clientY;
            // Sentinels to keep scroll within bounds
            if (el.scrollTop <= 0) {
                el.scrollTop = 1;
            } else if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
                el.scrollTop = el.scrollTop - 1;
            }
        };
        const onTouchMoveGuard = (e) => {
            const el = listRef.current;
            if (!el) return;
            const currentY = e.touches ? e.touches[0].clientY : e.clientY;
            const diff = currentY - startY; // >0 swiping down
            const atTop = el.scrollTop <= 0;
            const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
            if ((atTop && diff > 0) || (atBottom && diff < 0)) {
                e.preventDefault();
            }
        };
        const onWheelGuard = (e) => {
            const el = listRef.current;
            if (!el) return;
            const delta = e.deltaY;
            const atTop = el.scrollTop <= 0;
            const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
            if ((atTop && delta < 0) || (atBottom && delta > 0)) {
                e.preventDefault();
            }
        };

        // Attach listeners to the scrollable elements to keep touchmove local
        const popupEl = document.getElementById('orders-newOrdersPopup-popup');
        const listEl = listRef.current;
        if (popupEl) {
            popupEl.addEventListener('touchmove', stopProp, { passive: false });
            popupEl.addEventListener('wheel', stopProp, { passive: false });
        }
        if (listEl) {
            listEl.addEventListener('touchstart', onTouchStart, { passive: false });
            listEl.addEventListener('touchmove', onTouchMoveGuard, { passive: false });
            listEl.addEventListener('wheel', onWheelGuard, { passive: false });
            // Track scroll position to restore if iOS snaps
            const onScroll = () => {
                lastScrollTopRef.current = listEl.scrollTop;
            };
            const onTouchEnd = () => {
                // Defer to next frame to override any snap
                requestAnimationFrame(() => {
                    if (listEl) listEl.scrollTop = lastScrollTopRef.current;
                });
            };
            listEl.addEventListener('scroll', onScroll, { passive: true });
            listEl.addEventListener('touchend', onTouchEnd, { passive: true });
            // Save for cleanup
            listEl._mcOnScroll = onScroll;
            listEl._mcOnTouchEnd = onTouchEnd;
        }

        return () => {
            if (popupEl) {
                popupEl.removeEventListener('touchmove', stopProp, { passive: false });
                popupEl.removeEventListener('wheel', stopProp, { passive: false });
            }
            if (listEl) {
                listEl.removeEventListener('touchstart', onTouchStart, { passive: false });
                listEl.removeEventListener('touchmove', onTouchMoveGuard, { passive: false });
                listEl.removeEventListener('wheel', onWheelGuard, { passive: false });
                if (listEl._mcOnScroll) {
                    listEl.removeEventListener('scroll', listEl._mcOnScroll, { passive: true });
                    listEl._mcOnScroll = null;
                }
                if (listEl._mcOnTouchEnd) {
                    listEl.removeEventListener('touchend', listEl._mcOnTouchEnd, { passive: true });
                    listEl._mcOnTouchEnd = null;
                }
            }
            if (!isIOS()) {
                resumeScrolling();
            } else {
                const body = document.body;
                const top = body.style.top;
                // Restore original inline styles
                const prev = originalBodyStylesRef.current || {};
                body.style.position = prev.position || '';
                body.style.top = prev.top || '';
                body.style.left = prev.left || '';
                body.style.right = prev.right || '';
                body.style.overflow = prev.overflow || '';
                body.style.width = prev.width || '';
                const y = parseInt(top || '0', 10);
                window.scrollTo(0, Math.abs(y));
            }
        };
    }, []);
    return (
        <>
            <Popup
                title={t('orders.orderTypes.neworder')}
                onClose={props.onClose}
                id={'orders-newOrdersPopup-popup'}
            >
                <ListItems ref={listRef}>
                    {newOrderMethods.map((method, index) => {
                        return (
                            <ListItem
                            id={`orders-neworderspopup-listitem-${newOrderMethods[index].id}`}
                                key={index}
                                onClick={() => handleOnClick(method)}
                                cursor={'pointer'}
                                show={
                                    createOrderDetails[
                                        newOrderMethods[index].id
                                    ]
                                }
                            >
                                <Title>{method.name}</Title>
                                <ArrowIcon
                                    mobilePath={ArrowRightLight}
                                ></ArrowIcon>
                            </ListItem>
                        );
                    })}
                </ListItems>
            </Popup>
        </>
    );
};

export default NewOrdersPopup;

export const ListItems = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    width: 430px;
    /* Constrain height and enable scrolling so all options are visible */
    max-height: calc(100dvh - 180px);
    overflow-y: auto;
    /* Improve scrolling on touch devices */
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    touch-action: pan-y;
    overflow-anchor: none;
    padding-bottom: env(safe-area-inset-bottom);
    box-sizing: border-box;
    scrollbar-width: thin;
    
    ${media.smalDevice`
        /* Landscape small screens (e.g., ~700x300) */
        max-height: calc(100dvh - 160px);
        overflow-y: auto;
    `}
    ${media.mobileDevice`
    width: 310px;
    max-height: calc(100dvh - 160px);
    overflow-y: auto;
    `}
    
    /* iPhone SE landscape: aggressive constraint to prevent footer overlap */
    @media only screen and (max-device-height: 500px) and (orientation: landscape) {
        max-height: 55vh;
        width: 85vw;
        margin-top: 10px;
    }
`;
export const ListItem = styled.div`
    display: ${({ show }) => (show ? 'flex' : 'none')};
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    flex-direction: row;
    justify-content: space-between;
    margin: 1% 1% 7px 1%;
    color: #1010eb;
    cursor: ${({ cursor }) => cursor};
    font-family: 'AvenirNextWorld Demi';
    padding: 10px 10px 10px 20px;
    ${media.mobileDevice`
    
    `}
`;
export const ArrowIcon = styled.div`
    background: transparent url(${({ mobilePath }) => mobilePath}) 0% 0%
        no-repeat padding-box;
    opacity: 1;
    width: 24px;
    height: 24px;
    ${media.mobileDevice`
    
    `}
`;
export const Title = styled.div``;

// const getNewOrdersMethod = (category) => {
//     let component = null;
//     switch (category) {
//         case newOrderMethods[0].name:
//             //{ path: '/scheduleSurgery', component: ScheduleSurgery },
//             component = <Route
//                   path={'/scheduleSurgery'}
//                   component={ScheduleSurgery}
//               ></Route>;
//             //console.log(ScheduleSurgery);
//             console.log('menthod name', category);
//             break;
//         case newOrderMethods[1].name:
//             //component = <Equity />;
//             console.log('menthod name', category);
//             break;
//         case newOrderMethods[2].name:
//             //component = <ConsignmentBilling />;
//             console.log('menthod name', category);
//             break;
//         case newOrderMethods[3].name:
//             //component = <ConsignmentReturn />;
//             console.log('menthod name', category);
//             break;
//         default:
//             break;
//     }
//     return component;
// };
